import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { OverriddenGELDesignTokens } from '@client/GEL-design-tokens-middleware';

export const OptimizePreset = definePreset(Aura, OverriddenGELDesignTokens);
